export default "__VITE_ASSET__4939b36e__"